"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodeHtml = decodeHtml;
exports.decodeHTMLEntities = decodeHTMLEntities;

function decodeHtml(html) {
  // replace <!-- --> comments left by the translation tools
  var text = html.replace(/(<!--(?:(?!-->).)*-->)/, '');

  if (typeof document !== 'undefined') {
    var txt = document.createElement('div');
    txt.innerHTML = decodeHTMLEntities(text);

    if (txt.textContent) {
      return txt.textContent;
    } else {
      return txt.innerText;
    }
  }

  return html;
}

function decodeHTMLEntities(str) {
  // Replace < and > to prevent XSS injection.
  if (str && typeof str === 'string') {
    str = str.replace(/</g, '&lt;');
    str = str.replace(/>/g, '&gt;');
  }

  return str;
}